import React from 'react';
import ForgotPasswordForm from 'components/forgot-password';
import { createStyles } from '../../globalStyles';

const ForgotPasswordPage = (): JSX.Element => {
  const classes = createStyles();

  return (
    <div className={classes.formWrapper}>
      <h1 className={classes.title}>Reset Your Password</h1>
      <ForgotPasswordForm />
    </div>
  );
};

export default ForgotPasswordPage;
